import { Assignments } from '@features/ForestOwner/Search/Overview/Assignments/Assignments.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/assignments')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Oppdrag',
  },
})

function RouteComponent() {
  return <Assignments />
}
